// extracted by mini-css-extract-plugin
export var sliderRange = "_r9-2";
export var sliderRoot = "_r9-0";
export var sliderThumb = "_r9-3";
export var sliderTrack = "_r9-1";